import InvestmentMemo from "./InvestmentMemo";
import { useAtom } from "jotai";
import { showCompanyListAtom } from "../CompaniesLayout";
import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { MemoNavigator } from "./components/MemoNavigator";
import { useCompany } from "@/apps/CompanyApp/hooks/useCompany";
import { Spinner } from "@/ui/atoms/Spinner";

export default function InvestmentMemoPage() {
    const [showCompanyList] = useAtom(showCompanyListAtom);
    const company = useCompany();

    if (!company.company) {
        return <Spinner fullScreen />;
    }

    return (
        <div className="flex size-full">
            {!showCompanyList && (
                <SidebarPortal>
                    <MemoNavigator />
                </SidebarPortal>
            )}
            <InvestmentMemo />
        </div>
    );
}
